/**
 * Set cookie
 * @param name cookie name
 * @param value cookie value
 * @param days days after which cookie expires
 */
export function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${value || ""}${expires}; path=/`;
}
/**
 * Get cookie by name
 * @param name cookie name
 * @returns cookie value if it exists
 */
export function getCookie(name) {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(";");
    for (let index = 0; index < ca.length; index++) {
        let cookie = ca[index];
        while (cookie.charAt(0) === " ") {
            cookie = cookie.substring(1, cookie.length);
        }
        if (cookie.indexOf(nameEQ) === 0) {
            return cookie.substring(nameEQ.length, cookie.length);
        }
    }
    return "";
}
//# sourceMappingURL=cookies.js.map